import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles((theme) => ({
  firstSubContainer: {
    marginBottom: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
  },
  secondSubContainer: {
    marginRight: theme.spacing(1),
    width: "25%",
    marginBottom: theme.spacing(3),
  },
  secondSubContainerTitle: {
    fontSize: "1rem",
    color: "#898989",
  },
  secondSubContainerData: {
    color: theme.palette.secondary.dark,
  },
  summaryContainer: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  suggestedTitle: {
    color: "#898989",
    fontSize: "1.1rem",
  },
  label: {
    color: theme.palette.primary.dark,
    marginTop: theme.spacing(1),
  },
  requirementBox: {
    marginBottom: theme.spacing(2),
  },
  membersTitle: {
    color: "#898989",
    fontSize: "1.1rem",
    marginBottom: theme.spacing(2),
  },
  dataContainer: {
    marginBottom: theme.spacing(1),
    marginTop: theme.spacing(1),
  },
  infoBoxTitle: {
    fontSize: "1rem",
    color: "#898989",
    fontWeight: 500,
  },
  infoBoxData: {
    color: theme.palette.secondary.dark,
  },
  urlLink: {
    color: theme.palette.secondary.dark,
    wordWrap: "break-word",
    cursor: "pointer",
  },
  entityName: {
    fontWeight: 500,
    marginRight: "6px",
    fontSize: "1.075em",
  },
  entityType: {
    opacity: 0.5,
    fontSize: "1.075em",
  },
}))

export default styles
